import gsap from "gsap";

(function ($) {
    $(document).ready(function () {

        const targets = $(".animate-svg");

        targets.each((index, target) => {
            gsap.from(target, {
                scrollTrigger: {
                    start: "top bottom-=150",
                    end: "bottom center",
                    trigger: target,
                    onEnter: () => {
                        $(target).find("g").each((index, el) => {
                            gsap.to(el, {
                                duration: .35,
                                delay: (index + 1) / ($(target).find("g").length > 10 ? 8 : 6),
                                opacity: .8,
                            });
                        })
                    }
                }
            });
        })
    })
})(jQuery);